<template>
  <div class="main-container" :class="colorMode === 'dark' ? 'dark-block' : ''">
    <h2>Deepening bankers’ visibility on bankable, private companies across the continent</h2>
    <p>Identifying new bankable prospects is a time-consuming data gathering exercise. Asoko proactively maps thousands of corporates across sectors and value-chains. We work with banks to turn this data-set into actionable lead lists, feeding directly into proprietary workflows.</p>
  </div>
</template>

<script>
export default {
  name: 'banker-coverage-conversion',
  props: {
    colorMode: {
      type: String,
    },
  },
}
</script>
